import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivityLogModel } from '../../../models/activity-log/activity-log.model';
import * as Actions from './studies.action';

import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { StudySaleSubmission } from '../../../models/Study/study-sale-submission';
import * as selectors from './studies.selector';
import { StudyState } from './studies.reducer';
import { selectState } from './studies.selector';
import { firstValueFrom, Observable } from 'rxjs';
import { MediaGroup } from '../../../models/media/media-group.model';
import { StudyStatus } from '../../enums/study-status.enum';
import { StudyFile } from '../../../models/Study/study-file.model';
import { StudyDraftSubmissionAcknowledgementsRequestDto } from '../../../models/Study/study.model';

@Injectable()
export class StudiesFacade {
  
  studyState$ = this.store.select(selectState);
  studies$ = this.store.select(selectors.selectStudies);
  studiesLoaded$ = this.store.select(selectors.selectStudiesLoaded);
  selectStudiesError$ = this.store.select(selectors.selectStudiesError);

  activeSaleHorseStudy$ = this.store.select(selectors.selectActiveStudy);
  activeStudyProfile$ = this.store.select(selectors.selectActiveStudyProfile);

  activeStudyLoaded$ = this.store.select(selectors.selectActiveStudyLoaded);
  activeStudyStatus$ = this.store.select(selectors.selectActiveStudyStatus);
  statuses$ = this.store.select(selectors.selectStatuses);
  studyStatusError$ = this.store.select(selectors.selectStudyStatusError);
  studyStatusSuccess$ = this.store.select(selectors.selectStudyStatusSuccess);
  studyStatusUpdated$ = this.store.select(selectors.selectStudyStatusUpdated);

  activeStudyStatusId$ = this.store.select(selectors.selectActiveStudyStatusId);
  studyFileRows$ = this.store.select(selectors.selectStudyFileRows);

  mediaGroups$ = this.store.select(selectors.selectMediaGroups);
  mediaGroupsAll$ = this.store.select(selectors.selectMediaGroupsAll);
  mediaCategories$ = this.store.select(selectors.selectMediaCategories);
  rawMediaCategories$ = this.store.select(selectors.selectRawMediaCategories);
  missingMediaCategories$ = this.store.select(
    selectors.selectMissingMediaCategories
  );

  studyFiles$ = this.store.select(selectors.selectStudyFiles);
  studyFilesToUpload$ = this.store.select(selectors.selectStudyFilesToUpload);

  mp4StudyFiles$ = this.store.select(selectors.selectMp4StudyFiles);
  pdfStudyFiles$ = this.store.select(selectors.selectPdfStudyFiles);
  studyPdfFiles$ = this.store.select(selectors.selectStudyPdfFiles);
  xrayReportPdfFiles$ = this.store.select(selectors.selectStudyPdfFiles);
  additionalStudyFiles$ = this.store.select(
    selectors.selectAdditionalStudyFiles
  );
  unmatchedStudyFiles$ = this.store.select(selectors.selectUnmatchedStudyFiles);
  

  xrayAllStudyFiles$ = this.store.select(
    selectors.selectxRayAllStudyFiles(true)
  );
  matchedStudyFiles$ = this.store.select(selectors.selectxRayAllStudyFiles());
  studyFilesByTypeAndStatusMap$ = this.store.select(
    selectors.selectStudyFilesByTypeAndStatus()
  );
  approvedStudyFilesByTypeAndStatusMap$ = this.store.select(
    selectors.selectStudyFilesByTypeAndStatus(4)
  );
  startedActivityLogId$ = this.store.select(
    selectors.selectStartedActivityLogId
  );
  isActivityEnded$ = this.store.select(selectors.selectIsActivityEnded);
  studiesSearch$ = this.store.select(selectors.selectStudiesSearch);
  studiesSearchDisplay$ = this.store.select(
    selectors.selectStudiesSearchDisplay
  );
  studiesSearchLoaded$ = this.store.select(selectors.selectStudiesSearchLoaded);
  tabStatus$ = this.store.select(selectors.selectTabDisplayForEditStudy);

  studyFileMimeTypesLoaded$ = this.store.select(
    selectors.selectStudyFileMimeTypesLoaded
  );
  studyFileMimeTypes$ = this.store.select(selectors.selectStudyFileMimeTypes);
  studyFileDocTypesLoaded$ = this.store.select(
    selectors.selectStudyFileDocTypesLoaded
  );
  studyFileDocTypes$ = this.store.select(selectors.selectStudyFileDocTypes);
  studyFileDescriptionUpdated$ = this.store.select(
    selectors.selectStudyDescriptionUpdated
  );
  studyFileDocTypesUpdated$ = this.store.select(
    selectors.selectStudyFileDocTypesUpdated
  );
  studySaleSubmitted$ = this.store.select(selectors.selectStudySaleSubmitted);
  studySaleSubmittedErrors$ = this.store.select(
    selectors.selectStudySaleSubmittedErrors
  );
  selectSubmitStudyValidationMessages$ = this.store.select(
    selectors.selectSubmitStudyValidationMessages
  );

  cancelStudyAndDeleteFilesError$ = this.store.select(
    selectors.cancelStudyAndDeleteFilesError
  );

  cancelStudyAndDeleteFilesSuccess$ = this.store.select(
    selectors.cancelStudyAndDeleteFilesSuccess
  );
  setStudyActiveStatusError$ = this.store.select(
    selectors.setStudyActiveStatusError
  );

  setStudyActiveStatusSucess$ = this.store.select(
    selectors.setStudyActiveStatusSucess
  );

  saleHorseSettings$ = this.store.select(selectors.selectSaleSettings);

  isLoading$ = this.store.select(selectors.selectIsLoading);

  mergeSuccess$ = this.store.select(selectors.selectMergeSuccess);
  onCompleteBatchSuccess$ = this.store.select(selectors.selectOnCompleteBatchSuccess);
  onCompleteBatchError$ = this.store.select(selectors.selectOnCompleteBatchError);
  mergeError$ = this.store.select(selectors.selectMergeError);
  isStudyFileDelete$ = this.store.select(selectors.selectStudyFileDelete);
  studyFileError$ = this.store.select(selectors.selectStudyFileError);
  shareStudySuccess$ = this.store.select(selectors.selectShareStudySuccess);
  shareStudyError$ = this.store.select(selectors.selectShareStudyError);
  sharedStudyFiles$ = this.store.select(selectors.selectSharedStudyFiles);
  selectShareStudyUID$ = this.store.select(selectors.selectShareStudyUID);
  selectActivitPerformed$ = this.store.select(selectors.selectActivitPerformed);
  cancelStudySubmissionSuccess$ = this.store.select(
    selectors.cancelStudySubmissionSuccess
  );

  constructor(private store: Store) {}

  loadStudies(loadManifest: boolean = false): void {
    this.store.dispatch(Actions.GetStudies({ loadManifest }));
  }
  searchStudies(lotNumber: string) {
    this.store.dispatch(Actions.StudiesSearch({ lotNumber }));
  }
  getXraysMediaGroups(memberId: number, studyStatusId: number = StudyStatus.Draft): Observable<any> {
    return this.store.select(selectors.selectXrays(memberId, studyStatusId));
  }
  getXraysMediaGroupsByStudyFiles(studyFiles: StudyFile[]): Observable<any> {
    return this.store.select(selectors.selectXraysForPreview(studyFiles));
  }
  filterStudiesSearch(query: string) {
    this.store.dispatch(Actions.StudiesSearchFilter({ query }));
    //const lotNumber = query;
    //this.store.dispatch(Actions.StudiesSearch({ lotNumber }));
  }
  loadStudyById(
    studyId: number,
    loadStudyFilesBySaleHorse: boolean = true
  ): void {
    this.store.dispatch(
      Actions.GetStudyById({ studyId, loadStudyFilesBySaleHorse })
    );
  }

  loadStudyFiles(saleId: number, horseId: number): void {
    this.store.dispatch(Actions.GetStudyFiles({ saleId, horseId }));
  }

  loadStudyFilesByStudyId(studyId: number): void {
    this.store.dispatch(Actions.GetStudyFilesByStudyId({ studyId }));
  }

  loadStudyPdfFilesByStudyId(saleId: number, horseId: number): void {
    this.store.dispatch(Actions.GetStudyPdfFilesByStudyId({ saleId, horseId }));
  }

  loadStudyFilesBySaleHorse(saleHorse: SaleHorse): void {
    this.store.dispatch(Actions.GetStudyFilesBySaleHorse({ saleHorse }));
  }

  loadStudyFilesWithSaleHorse(saleId: number, horseId: number): void {
    this.store.dispatch(
      Actions.GetStudyFilesWithSaleHorse({ saleId, horseId })
    );
  }
  setStudySubmitToSale(studySale: StudySaleSubmission): void {
    this.store.dispatch(Actions.StudySubmitToSale({ studySale }));
  }

  loadStatuses(): void {
    this.store.dispatch(Actions.GetStatuses());
  }

  loadMediaGroups(): void {
    this.store.dispatch(Actions.GetMediaGroups());
  }

  shareStudy(data: any): void {
    this.store.dispatch(Actions.ShareClinicalData({ shareStudy: data }));
  }

  createStudyFile(
    saleId: number,
    horseId: number,
    file: File,
    studyId?: number,
    isAdditional?: boolean,
    mediaCategoryId?: number
  ): void {
    this.store.dispatch(
      Actions.CreateStudyFile({
        saleId,
        horseId,
        file,
        studyId,
        isAdditional,
        mediaCategoryId,
      })
    );
  }

  cancelStudyAndDeleteFiles(
    saleId: number,
    horseId: number,
    studyId: number
  ): void {
    this.store.dispatch(
      Actions.CancelStudyFiles({
        saleId,
        horseId,
        studyId,
      })
    );
  }

  cancelStudySubmission(saleId: number, horseId: number): void {
    this.store.dispatch(
      Actions.CancelStudySubmission({
        saleId,
        horseId,
      })
    );
  }

  setStudyActiveStatus(studyId: number, isActive: boolean): void {
    this.store.dispatch(
      Actions.SetStudyActiveStatusFiles({
        studyId,
        isActive,
      })
    );
  }

  updateStudyFile(
    studyFileId: number,
    mediaCategoryId: number,
    replacing: boolean,
    extra: boolean,
    isAdditional: boolean,
    studyId?: number,
    saleId?: number,
    horseId?: number
  ): void {
    this.store.dispatch(
      Actions.UpdateStudyFile({ studyFileId, isAdditional, mediaCategoryId, replacing, extra, studyId, saleId, horseId })
    );
  }

  deleteStudyFile(studyFileId: number): void {
    this.store.dispatch(Actions.DeleteStudyFile({ studyFileId }));
  }

  updateStudyFileStatuses(
    studyFileIds: number[],
    statusId: number,
    reason?: string,
    notificationData?: any,
    acknowledgementData?: StudyDraftSubmissionAcknowledgementsRequestDto
  ): void {
    this.store.dispatch(
      Actions.UpdateStudyFileStatuses({
        studyFileIds,
        statusId,
        reason,
        notificationData,
        acknowledgementData

      })
    );
  }

  updateStudyFilesAutoApprove(
    studyFileIds: number[],
    statusId: number,
    reason?: string,
    notificationData?: any,
    acknowledgementData?: StudyDraftSubmissionAcknowledgementsRequestDto
  ): void {
    this.store.dispatch(
      Actions.UpdateStudyFileStatusesAutoApprove({
        studyFileIds,
        statusId,
        reason,
        notificationData,
        acknowledgementData
      })
    );
  }

  clearStudyStatus() {
    this.store.dispatch(Actions.ClearStudyStatusResponseState());
  }
  clearCancelStudyAndDeleteFilesSuccess() {
    this.store.dispatch(Actions.ClearCancelStudyAndDeleteFilesSuccess());
  }
  clearStudyStatusState() {
    this.store.dispatch(Actions.ClearStudyStatusState());
  }
  clearStudyActiveStatus() {
    this.store.dispatch(Actions.ClearSetStudyActiveStatusFiles());
  }
  updateStudyStatus(
    studyId: number,
    statusId: number,
    studyFileIds: number[]
  ): void {
    this.store.dispatch(
      Actions.UpdateStudyStatus({ studyId, statusId, studyFileIds })
    );
  }

  getSaleHorseStudies(saleId: number, horseId: number, isHideSpinner: boolean = true): void {
    this.store.dispatch(Actions.GetSaleHorseStudies({ saleId, horseId, isHideSpinner }));
  }

  resetData(): void {
    this.store.dispatch(Actions.ResetData());
  }

  startActivity(activity: ActivityLogModel) {
    this.store.dispatch(Actions.StartActivity({ activity }));
  }
  endActivity(activityLogId: number) {
    this.store.dispatch(Actions.EndActivity({ activityLogId }));
  }
  loadStudyFileMimeTypes() {
    this.store.dispatch(Actions.GetStudyFilesMimeTypes());
  }
  loadStudyFileDocTypes(isReport: boolean) {
    this.store.dispatch(Actions.GetStudyFilesDocTypes({ isReport }));
  }
  updateStudyDescription(studyId: number, description: string) {
    this.store.dispatch(
      Actions.UpdateStudyDescription({ studyId, description })
    );
  }
  updateStudyDocType(
    studyFileId: number,
    docTypeId: number,
    docTypeName: string,
    isReport: boolean
  ) {
    this.store.dispatch(
      Actions.UpdateStudyFileDocType({
        studyFileId,
        docTypeId,
        docTypeName,
        isReport,
      })
    );
  }
  updateStudySelectedTab(studySubmissionId: number) {
    this.store.dispatch(
      Actions.UpdateSelectedTab({ submissionStatusId: studySubmissionId })
    );
  }

  loadSaleSettings(saleId: number, horseId: number): void {
    this.store.dispatch(Actions.GetSaleSettings({ saleId, horseId }));
  }

  loadSharedStudyFiles(encrypted: string): void {
    this.store.dispatch(
      Actions.GetSharedClinicalData({ protected: encrypted })
    );
  }

  mergeStudies(studyId: number, studyIds: number[]): void {
    this.store.dispatch(Actions.mergeStudies({ studyId, studyIds }));
  }
  onCompleteBatch(data: any): void {
    this.store.dispatch(Actions.OnCompleteBatch({ data }));
  }
  clearMergeSuccess(): void {
    this.store.dispatch(Actions.clearMergeSuccess());
  }

  clearStudySubmitToSale(): void {
    this.store.dispatch(Actions.clearStudySubmitToSale());
  }
  clearCancelStudyAndDeleteFilesError(): void {
    this.store.dispatch(Actions.clearCancelStudyAndDeleteFilesError());
  }
  clearStudiesLoaded(): void {
    this.store.dispatch(Actions.clearStudiesLoaded());
  }
  clearDeleteFileError(): void {
    this.store.dispatch(Actions.clearDeleteFileError());
  }
  clearSharedStudyState(): void {
    this.store.dispatch(Actions.clearSharedStudyState());
  }
  resetActivityState() {
    this.store.dispatch(Actions.ResetActivityState());
  }
  async hasStudyStateChanged(): Promise<boolean> {
    return await firstValueFrom(this.selectActivitPerformed$);
  }

}
